var rule = function rule() {
  return '';
};
export default rule;